import React, { useState } from 'react';
import { Button, FormControl, FormControlLabel, InputLabel, MenuItem, Typography, Select, Accordion, AccordionSummary, AccordionDetails, AccordionActions } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';


const style = {
    formControl: {
        margin: "0px 20px",
        minWidth: 120,
        flexGrow: 1
    },
    selectEmpty: {
        marginTop: 0,
    },
};

// <SelectWithAdd label="" collection={[]} selection="" handleChangeSelection={(param)=>{}} handleAdd={()=>{} ></SelectWithAdd>

const ChildSelect = (props) => {
    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth:'400px', margin: "0px" }}>
            <FormControl variant="outlined" style={style.formControl}>
                <InputLabel id="demo-simple-select-outlined-label">{props.label}</InputLabel>
                <Select
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    value={props.selection}
                    onChange={props.handleChangeSelection}
                    label={props.label}
                    style={{width:'100%'}}
                    >
                    {props.collection.map((key, index) => (
                        <MenuItem key={index} value={key}>
                            <Typography>
                                {key}
                            </Typography>
                        </MenuItem>
                        ))}
                </Select>
            </FormControl>
        </div>
    )
}

const SelectAccordion = (props) => {
    
    return (
        <div className="">
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-label="Expand"
                    aria-controls="additional-actions1-content"
                    id="additional-actions1-header"
                >
                    <FormControlLabel
                        aria-label="Acknowledge"
                        onClick={(event) => event.stopPropagation()}
                        onFocus={(event) => event.stopPropagation()}
                        control={<ChildSelect {...props}/>}
                        label=""
                    />
                </AccordionSummary>
                <AccordionDetails>
                    {
                        props.children
                    }
                </AccordionDetails>
            </Accordion>
        </div>
    )
}

export default SelectAccordion;